const url = {
  baseUrl: "https://webserver.medicalwisdom.in",
};

export default url;
